
import { computed, defineComponent, getCurrentInstance, watch } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';
import { radarLog } from '~/common/radar';

const AIAgeConfirmPopup = defineComponent({
    components: {
        vanActionSheet: ActionSheet,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['confirm', 'cancel'],
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const title = computed(() => {
            return proxy?.$root?.$t?.('confirm_verification');
        });

        const description = computed(() => {
            return proxy?.$root?.$t?.('useragreement_verification');
        });

        const description2 = computed(() => {
            return 'Este conteúdo gerado por IA pode não ser adequado para menores. Apenas adultos podem continuar ou visualizar este conteúdo. Por favor, confirme que você tem pelo menos 18 anos. Coletamos registros de chat anônimos e dados de uso para permitir que você utilize nosso produto. Seus dados pessoais permanecerão confidenciais.';
        });
        const showSelf = computed(() => {
            return props?.show;
        });
        const onConfirm = () => {
            radarLog({
                name: 'PWA_WEB_AI_AGE_CONFIRM_CONFIRM',
                event_type: 'show',
                category: 'KWAI_SHARE',
                message: 'PWA_WEB_AI_AGE_CONFIRM_CONFIRM',
                src: window.location.href,
            });
            emit('confirm');
        };

        const onCancel = () => {
            radarLog({
                name: 'PWA_WEB_AI_AGE_CONFIRM_CANCEL',
                event_type: 'show',
                category: 'KWAI_SHARE',
                message: 'PWA_WEB_AI_AGE_CONFIRM_CANCEL',
                src: window.location.href,
            });
            emit('cancel');
        };

        watch(
            () => props.show,
            newValue => {
                if (newValue) {
                    radarLog({
                        name: 'PWA_WEB_AI_AGE_CONFIRM_SHOW',
                        event_type: 'show',
                        category: 'KWAI_SHARE',
                        message: 'PWA_WEB_AI_AGE_CONFIRM_SHOW',
                        src: window.location.href,
                    });
                }
            }
        );

        return {
            onConfirm,
            onCancel,
            description,
            description2,
            title,
            showSelf,
        };
    },
});
export default AIAgeConfirmPopup;
